export enum DisplayRule {
  // eslint-disable-next-line no-unused-vars
  Error,
  // eslint-disable-next-line no-unused-vars
  SOME,
  // eslint-disable-next-line no-unused-vars
  FEW,
  // eslint-disable-next-line no-unused-vars
  MANY,
}

const SHOW_NUMBER_BASELINE = 50
const SHOW_LEADER_BASELINE = 1000

export default function getSimplifiedTotalBuyers (totalBuyers: number) {
  const result = {
    origin: totalBuyers,
    value: totalBuyers,
    type: DisplayRule.Error
  }

  if (totalBuyers == null || isNaN(totalBuyers) || totalBuyers <= 0) {
    return result
  }

  if (totalBuyers < SHOW_NUMBER_BASELINE) {
    result.type = DisplayRule.SOME
  } else if (totalBuyers < SHOW_LEADER_BASELINE) {
    result.type = DisplayRule.FEW
  } else {
    result.value = Math.trunc(totalBuyers / 1000)
    result.type = DisplayRule.MANY
  }

  return result
}
